module.exports = __webpack_public_path__ + "media/images/profile_logo/img_building-d23165ba266dd7729123bd35d45764f4.png";